import { CLEAN_STATE } from '../sagas/actions';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILURE = 'AUTH_FAILURE';
export const SET_AUTH_LOADING = 'SET_LOADING';

const initialState = {
  token: '',
  name: null,
  error: null
};

const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AUTH_SUCCESS: {
      return { ...state, token: payload.token, name: payload.name };
    }
    case AUTH_FAILURE: {
      return { ...state, error: payload };
    }
    case CLEAN_STATE: {
      return { ...initialState };
    }
    default:
      return state;
  }
};

export default authReducer;


// WEBPACK FOOTER //
// ./src/reducers/auth.js